import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';
import { LessonVersionData, LessonVersionVars } from '../gql-types';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import ContentGraphQL from '../gql';

let contentApolloClient: ApolloClient<NormalizedCacheObject> = null;

export const useLessonVersion = (lessonkey: number, lessonVersion: number) => {
  if (!contentApolloClient) {
    contentApolloClient = ApolloClientService.create(Config.CONTENT_GQL);
  }

  const {
    loading,
    error,
    data: versionData
  } = useQuery<LessonVersionData, LessonVersionVars>(
    ContentGraphQL.Query.LESSON_VERSION_ASSET,
    {
      client: contentApolloClient,
      fetchPolicy: 'network-only',
      variables: {
        lessonkey,
        lessonVersion
      }
    }
  );

  return {
    loading,
    error,
    lessonVersionAsset: versionData?.lessonVersionAsset || null
  };
};
